import { render, staticRenderFns } from "./LatestReviews.vue?vue&type=template&id=4ccd2ccf"
import script from "./LatestReviews.vue?vue&type=script&lang=js"
export * from "./LatestReviews.vue?vue&type=script&lang=js"
import style0 from "./LatestReviews.vue?vue&type=style&index=0&id=4ccd2ccf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports